import { boolean, number, object, string, z } from "zod";

export const SearchPageQueryInputsParams = object({
  Id: number().optional(),

  minAge: number().optional(),
  maxAge: number().optional(),

  minHeight: number().optional(),
  maxHeight: number().optional(),

  minWeight: number().optional(),
  maxWeight: number().optional(),

  country: number().optional(),
  city: number().optional(),

  zodiacSign: string().optional(),
  eyeColor: number().optional(),
  hairColor: number().optional(),
  appearanceType: string().optional(),

  children: number().optional(),
  englishSkill: number().optional(),
  religion: number().optional(),
  smoking: number().optional(),
  drinking: number().optional(),

  online: boolean().optional(),
  hasVideo: boolean().optional(),
  hasIntroVideo: boolean().optional(),
  birthdaySoon: boolean().optional(),
  newest: boolean().optional(),
  ladiesWithCam: boolean().optional(),
  topLadies: boolean().optional(),
});

export type SearchPageQueryInputsParams = z.infer<
  typeof SearchPageQueryInputsParams
>;

export const SearchPagePaginationParams = object({
  pageSize: number(),
  startIndex: number(),
});

export const SearchPageQueryParams = SearchPagePaginationParams.merge(
  z.object({
    urlSearchParams: SearchPageQueryInputsParams.nullable(),
  }),
);

export type SearchPageQueryParams = z.infer<typeof SearchPageQueryParams>;

export const SearchPageUrlSearchParams = SearchPageQueryInputsParams.extend({
  page: number().optional(),
});

export type SearchPageUrlSearchParams = z.infer<
  typeof SearchPageUrlSearchParams
>;
